import { useEffect } from 'react'
import BottomSheetContent from './BottomSheetContent'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  type: 'ROLLING' | 'TRAILING'
  ScreenName: string
}

export const AboutThisRankContent = ({ onDismiss, type, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'About this rank'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='text-[#6A6E6E] leading-[150%] text-[14px]'>
        {type === 'TRAILING'
          ? 'This is the fund’s ranking based only on its returns compared to other funds in the category.'
          : 'This is the fund’s ranking based only on its rolling returns compared to other funds in the category.'}
      </div>
    </BottomSheetContent>
  )
}
